import IEventService from '../../../../eventService/IEventService';
import { getServices } from '../../../../../infra/startup';
import {
  EventServiceCallBackType,
  ListenerHandlerType,
  OnboardingAgentEvents
} from '../../../../eventService/types';

class EventManager {
  private _eventService: IEventService;

  constructor() {
    const services = getServices();
    this._eventService = services?.eventService;
  }

  public subscribeToEvent(
    eventName: string,
    callback: EventServiceCallBackType
  ): Promise<ListenerHandlerType> {
    return this._eventService.subscribe(eventName, callback);
  }

  public sendOnboardingFailedToLaunchEvent(): void {
    this._eventService.publish(
      OnboardingAgentEvents.onboardingAgentFailedToLaunch,
      undefined
    );
  }

  public sendWebOnboardingStageStartedEvent(
    appSessionId: string,
    serviceId?: string
  ): void {
    this._eventService.publish(
      this._eventService.eventNames.webOnboardingStageStarted,
      {
        appSessionId,
        serviceId
      }
    );
  }

  public sendOnboardingStageFinishedEvent(
    appSessionId: string,
    serviceId: string,
    resultData: {
      result: 'success' | 'failed' | 'cancelled';
      output?: Record<string, any>;
      xCorrelationId: string;
    },
    xCorrelationId: string
  ): void {
    this._eventService.publish(
      this._eventService.eventNames.webOnboardingStageFinished,
      {
        appSessionId,
        serviceId,
        result: {
          result: resultData?.result,
          xCorrelationId: resultData?.xCorrelationId || xCorrelationId
        }
      }
    );
  }
}
export default EventManager;
